'use client';

import type { ReactNode } from 'react';
import { Button } from '../../../../../components/styled/button';

export function FlatToolCardActionButton({
  children,
  onClick,
}: {
  children: ReactNode;
  onClick: () => void;
}) {
  return (
    <Button
      size="xs"
      variant="outline"
      type="button"
      onClick={onClick}
      h="6"
      minH="6"
      px={2}
      bg="transparent"
      borderColor="border.neutral.muted"
      _hover={{ bg: 'bg.subtle', color: 'fg.default' }}
    >
      {children}
    </Button>
  );
}
